module.exports = __webpack_public_path__ + "img/objects-align-center-vertical.b49b3313.svg";